import axios from "axios";
import store from '../store'
import router from '../router'
import { Base64 } from 'js-base64'
const NGINX = ''
// console.log(process)
// const VUE_APP_URL = process.env.VUE_APP_URL
// const baseUrl = (VUE_APP_URL ? VUE_APP_URL : NGINX)
// 创建axios实例
const isProd =true //是否生产环境
let baseUrl = isProd ? 'https://boschqrmp.bshg.com.cn' : 'https://boschcstest.bshg.com.cn'
const service = axios.create({
  baseURL: baseUrl,
  timeout: 50000, // 请求超时时间
})
// console.log('当前环境配置地址:', VUE_APP_URL, baseUrl)
// request拦截器,在请求之前做一些处理
service.interceptors.request.use(
  (config) => {
    if (config.url && config.url.indexOf('/') != 0) {
      config.url = '/' + config.url
    }
    // if (store.state.token) {
      // 给请求头添加-token
      // config.headers['Authorization'] = store.state.token
    // }
    config.headers = {
      ...config.headers,
      'Content-Type': 'application/json;charset=UTF-8',
    }
    return config
  },
  (error) => {
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器,数据返回后进行一些处理
service.interceptors.response.use(
  (response) => {
    console.log('响应拦截: ',response)
    const res = response.data
    if (res.status == 200) {
      return res
    } else {
      Promise.reject(res.msg)
      return res
    }
  },
  (error) => {
    Promise.reject('网络异常')
  }
)
export default service
